import { ApiBaseData } from '@ibe/api';
import RentalCarOfficeWithDistanceWrapper from '../Models/RentalCarOfficeWithDistanceWrapper';

abstract class DistanceUtil {
  public static haversineDistance = (
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number
  ): number => {
    const toRadians = (deg: number) => (deg * Math.PI) / 180;

    const R = 6371;
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  };

  public static sortByHaversineDistance = (
    locations: RentalCarOfficeWithDistanceWrapper[],
    refPoint: ApiBaseData
  ): RentalCarOfficeWithDistanceWrapper[] => {
    return locations
      .map(location => ({
        ...location,
        distance: DistanceUtil.haversineDistance(
          refPoint.latitude as number,
          refPoint.longitude as number,
          location.latitude as number,
          location.longitude as number
        )
      }))
      .sort((a, b) => a.distance! - b.distance!);
  };
}

export default DistanceUtil;
